var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import Box from '@mui/material/Box';
import { useEffect, useState, useMemo, useCallback } from 'react';
import { useDataProvider, useTranslate, useNotify, useRefresh, } from 'react-admin';
import AllOrganizations from './AllOrganization';
import YourDashboard from './YourDashborad';
import PaymentRecord from './PaymenrRecord';
import Cooperation from './Cooperation';
// import BannedIp from './BannedIP';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { acl } from '../utils/dummyData';
import { Grid, useMediaQuery } from '@mui/material';
import { generateInvoice } from '../utils/invoiceGenerator';
import CreateTrialAccountButton from './CreateTrialAccountButton';
import MaintenanceNotification from '../utils/maintainenceNotification';
import { DashboardDataProvider } from './DashboardContext';
var Dashboard = function (props) {
    var translate = useTranslate();
    var notify = useNotify();
    var refresh = useRefresh();
    var _a = useState(acl), acessControlList = _a[0], setAcessControlList = _a[1];
    var _b = useState(""), userOrg = _b[0], setUserOrg = _b[1];
    var _c = useState(true), isInitialLoading = _c[0], setIsInitialLoading = _c[1];
    var dataProvider = useDataProvider();
    // Memoize user authentication and ACL loading
    var loadUserData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var cachedAuth, data, newACList, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    _l.trys.push([0, 3, 4, 5]);
                    cachedAuth = (_a = JSON.parse(localStorage.getItem('auth'))) !== null && _a !== void 0 ? _a : {};
                    if (!cachedAuth.id) return [3 /*break*/, 2];
                    return [4 /*yield*/, dataProvider.getOneWithoutDataJSON("users", { id: cachedAuth.id })];
                case 1:
                    data = _l.sent();
                    newACList = ((_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.ACL) || {};
                    setAcessControlList(newACList);
                    localStorage.setItem("userACL", JSON.stringify(newACList));
                    setUserOrg((_f = (_e = (_d = (_c = data.profile) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d['current_organization']) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : "N/A");
                    localStorage.setItem("appBarOrg", (_k = (_j = (_h = (_g = data.profile) === null || _g === void 0 ? void 0 : _g.info) === null || _h === void 0 ? void 0 : _h['current_organization']) === null || _j === void 0 ? void 0 : _j[1]) !== null && _k !== void 0 ? _k : "N/A");
                    refresh();
                    _l.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    error_1 = _l.sent();
                    console.error(error_1);
                    localStorage.setItem("appBarOrg", "N/A");
                    localStorage.setItem("userOrgId", "N/A");
                    notify(translate('error.ACL.getACLFailed'), { type: 'error' });
                    return [3 /*break*/, 5];
                case 4:
                    setIsInitialLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [dataProvider, notify, translate, refresh]);
    useEffect(function () {
        loadUserData();
    }, [loadUserData]);
    var _d = useState(0), selectedTab = _d[0], setSelectedTab = _d[1];
    var isMobileScreen = useMediaQuery("(max-width: 750px)");
    // Memoize tab change handler to prevent unnecessary re-renders
    var handleTabChange = useCallback(function (event, newValue) {
        setSelectedTab(newValue);
    }, []);
    // Memoize invoice language calculation
    var langForInvoice = useMemo(function () {
        var _a;
        return ((_a = JSON.parse(localStorage.getItem('auth'))) === null || _a === void 0 ? void 0 : _a.language) === 'en' ? 'en' : 'zh';
    }, []);
    var handleDownloadInvoice = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var dummyInvoiceData, pdfBlob, url, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dummyInvoiceData = {
                        "id": "9d119e1f-0608-4a2a-951b-b3af0f7fb63e",
                        "product": "Standard package",
                        "status": "Completed",
                        "quota": 30,
                        "charge": 9999999,
                        "stripeFee": 3.33,
                        "created_at": "2025-02-24T18:16:08.658Z",
                        "organization": {
                            "orgName": "Guild",
                            "isFake": false,
                        },
                        "buyer": {
                            "First_name": "Rouge",
                            "Last_name": "Rouge",
                            "email": "jackyyeung1022@gmail.com",
                        },
                        "paymentInfo": {
                            "address": {
                                "country": "HK",
                            },
                            "currency": "hkd"
                        }
                    };
                    return [4 /*yield*/, generateInvoice(dummyInvoiceData, langForInvoice)];
                case 1:
                    pdfBlob = _a.sent();
                    url = window.URL.createObjectURL(pdfBlob);
                    link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "invoice-".concat(dummyInvoiceData.id, ".pdf"));
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    return [2 /*return*/];
            }
        });
    }); }, [langForInvoice]);
    // Removed loading spinner - UI displays immediately
    return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsxs(Grid, { item: true, xs: 12, children: [_jsx(MaintenanceNotification, {}), _jsx(Box, { px: isMobileScreen ? 1 : 2, sx: {
                            overflowX: 'hidden',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'wrap'
                        }, children: _jsx(Box, { sx: { flexGrow: 1 }, children: acessControlList.dashboard_admin.view ? (_jsxs(Tabs, { variant: "scrollable", scrollButtons: "auto", value: selectedTab, onChange: handleTabChange, sx: {
                                    backgroundColor: "#1561a5",
                                    borderRadius: '8px',
                                    marginTop: '1.3rem',
                                    width: '100%',
                                    minHeight: isMobileScreen ? '48px' : '64px',
                                    '& .MuiTabs-flexContainer': {
                                        flexWrap: 'nowrap',
                                    },
                                    '& .MuiTabs-scroller': {
                                        overflow: 'auto !important',
                                        scrollbarWidth: 'none',
                                        '&::-webkit-scrollbar': {
                                            display: 'none'
                                        }
                                    }
                                }, TabIndicatorProps: {
                                    style: {
                                        backgroundColor: '#03a9f4',
                                        height: 6,
                                        borderRadius: '1.5px',
                                    },
                                }, children: [_jsx(Tab, { label: translate('pages.dashboard.title.allOrganizations'), sx: {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            minHeight: isMobileScreen ? '48px' : '64px',
                                            fontSize: isMobileScreen ? '0.875rem' : '1rem',
                                            '&.Mui-selected': {
                                                color: 'white',
                                            },
                                        } }), _jsx(Tab, { label: "".concat(translate('pages.dashboard.title.yourOrganization')), sx: {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            minHeight: isMobileScreen ? '48px' : '64px',
                                            fontSize: isMobileScreen ? '0.875rem' : '1rem',
                                            '&.Mui-selected': {
                                                color: 'white',
                                            },
                                        } }), _jsx(Tab, { label: translate('paymentRecord.transactionRecord'), sx: {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            minHeight: isMobileScreen ? '48px' : '64px',
                                            fontSize: isMobileScreen ? '0.875rem' : '1rem',
                                            '&.Mui-selected': {
                                                color: 'white',
                                            },
                                        } }), _jsx(Tab, { label: translate('Cooperation.title'), sx: {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            minHeight: isMobileScreen ? '48px' : '64px',
                                            fontSize: isMobileScreen ? '0.875rem' : '1rem',
                                            '&.Mui-selected': {
                                                color: 'white',
                                            },
                                        } }), _jsx(CreateTrialAccountButton, {})] })) : acessControlList.dashboard_normal.view ? (_jsxs(Tabs, { value: selectedTab, onChange: handleTabChange, sx: {
                                    backgroundColor: "#1561a5",
                                    borderRadius: '8px',
                                    marginTop: '1.3rem',
                                    width: '100%',
                                    minHeight: isMobileScreen ? '48px' : '64px',
                                    '& .MuiTabs-flexContainer': {
                                        flexWrap: 'nowrap',
                                    }
                                }, TabIndicatorProps: {
                                    style: {
                                        backgroundColor: '#03a9f4',
                                        height: 6,
                                        borderRadius: '1.5px',
                                    },
                                }, children: [_jsx(Tab, { label: "".concat(translate('pages.dashboard.title.yourOrganization')), sx: {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            minHeight: isMobileScreen ? '48px' : '64px',
                                            fontSize: isMobileScreen ? '0.875rem' : '1rem',
                                            '&.Mui-selected': {
                                                color: 'white',
                                            },
                                        } }), _jsx(Tab, { label: translate('paymentRecord.transactionRecord'), sx: {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            minHeight: isMobileScreen ? '48px' : '64px',
                                            fontSize: isMobileScreen ? '0.875rem' : '1rem',
                                            '&.Mui-selected': {
                                                color: 'white',
                                            },
                                        } })] })) : _jsx(Tabs, { variant: "scrollable", scrollButtons: "auto", value: selectedTab, onChange: function (event, newValue) { return setSelectedTab(newValue); }, sx: {
                                    backgroundColor: "#1561a5",
                                    borderRadius: '8px',
                                    marginTop: '1.3rem',
                                    width: '100%',
                                    minHeight: isMobileScreen ? '48px' : '64px',
                                    '& .MuiTabs-flexContainer': {
                                        flexWrap: 'nowrap',
                                    },
                                    '& .MuiTabs-scroller': {
                                        overflow: 'auto !important',
                                        scrollbarWidth: 'none',
                                        '&::-webkit-scrollbar': {
                                            display: 'none'
                                        }
                                    }
                                }, TabIndicatorProps: {
                                    style: {
                                        backgroundColor: '#03a9f4',
                                        height: 6,
                                        borderRadius: '1.5px',
                                    },
                                }, children: _jsx(Tab, { label: translate('paymentRecord.transactionRecord'), sx: {
                                        color: 'white',
                                        fontWeight: 'bold',
                                        textTransform: 'none',
                                        minHeight: isMobileScreen ? '48px' : '64px',
                                        fontSize: isMobileScreen ? '0.875rem' : '1rem',
                                        '&.Mui-selected': {
                                            color: 'white',
                                        },
                                    } }) }) }) })] }), _jsx(Grid, { item: true, xs: 12, sx: { mt: isMobileScreen ? 1 : 2, px: isMobileScreen ? 1 : 2 }, children: acessControlList.dashboard_admin.view ? (_jsxs(_Fragment, { children: [selectedTab === 0 && _jsx(AllOrganizations, {}), selectedTab === 1 && _jsx(YourDashboard, {}), selectedTab === 2 && _jsx(PaymentRecord, {}), selectedTab === 3 && _jsx(Cooperation, {})] })) : acessControlList.dashboard_normal.view ? (_jsxs(_Fragment, { children: [selectedTab === 0 && _jsx(YourDashboard, {}), selectedTab === 1 && _jsx(PaymentRecord, {})] })) : _jsx(PaymentRecord, {}) })] }));
};
// Main Dashboard component wrapped with data provider
var DashboardWithProvider = function (props) {
    return (_jsx(DashboardDataProvider, { children: _jsx(Dashboard, __assign({}, props)) }));
};
export default DashboardWithProvider;
